import { Modal } from 'admin-web-ui'
import React from 'react'
import { ChangePasswordForm } from '../ChangePasswordForm'

interface Props {
  visible: boolean
  onClose: () => unknown
}

export const ChangePasswordModal: React.FC<Props> = (props) => (
  <Modal
    open={props.visible}
    title="Change Password"
    onCancel={props.onClose}
    footer={null}
    width={453}
  >
    {/* Ensure form re-mounts each time modal is shown so that form state is reset */}
    {props.visible && (
      <ChangePasswordForm onSuccess={props.onClose} onCancel={props.onClose} />
    )}
  </Modal>
)
